 
import http from "@/http/service"
 
export default function DeletarUsuario(idUsuario=0){

    return http.delete(`/parceiro/usuarios/${idUsuario}`)

}